import { c as _c } from "react/compiler-runtime";
import type { JSX } from "react";
import { useObjectUrl } from "@/hooks/useObjectUrl";
enum FILE_TYPES {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  UNKNOWN = "UNKNOWN",
}
const getFileType = (file: File): FILE_TYPES => {
  if (file.type.includes("image")) {
    return FILE_TYPES.IMAGE;
  }
  if (file.type.includes("video")) {
    return FILE_TYPES.VIDEO;
  }
  if (file.type.includes("audio")) {
    return FILE_TYPES.AUDIO;
  }
  return FILE_TYPES.UNKNOWN;
};
export default function CreateDropSelectedFilePreview(t0) {
  const $ = _c(15);
  const {
    file
  } = t0;
  const fileType = getFileType(file);
  const previewFile = fileType === FILE_TYPES.UNKNOWN ? null : file;
  const previewUrl = useObjectUrl(previewFile);
  let t1;
  if ($[0] !== previewUrl) {
    t1 = previewUrl ? <img src={previewUrl} alt="" className="tw-h-full tw-w-full tw-object-contain tw-object-center" /> : <></>;
    $[0] = previewUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== file || $[3] !== previewUrl) {
    t2 = previewUrl ? <video className="tw-h-full tw-w-full" controls={true}><source src={previewUrl} type={file.type} />Your browser does not support the video tag.</video> : <></>;
    $[2] = file;
    $[3] = previewUrl;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== file || $[6] !== previewUrl) {
    t3 = previewUrl ? <audio className="tw-w-full" controls={true}><source src={previewUrl} type={file.type} />Your browser does not support the audio tag.</audio> : <></>;
    $[5] = file;
    $[6] = previewUrl;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <></>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t5 = {
      [FILE_TYPES.IMAGE]: t1,
      [FILE_TYPES.VIDEO]: t2,
      [FILE_TYPES.AUDIO]: t3,
      [FILE_TYPES.UNKNOWN]: t4
    };
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const components = t5;
  const t6 = components[fileType];
  let t7;
  if ($[13] !== t6) {
    t7 = <div className="tw-mt-2 tw-flex tw-gap-x-3"><div className="tw-h-full tw-w-full">{t6}</div></div>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}